import { useFeatureFlagEnabled, useFeatureFlagPayload as usePostHogFeatureFlagPayload } from '@posthog/react';

export type FeatureFlagPayloadMap = {
  'video-cover-upload': { allowedCompanyIds: number[] };
  'floorplan-interactive-editor': { allowedCompanyIds: number[] };
};

export type FeatureFlag = keyof FeatureFlagPayloadMap;

export const useFeatureFlag = (key: FeatureFlag): boolean => useFeatureFlagEnabled(key) ?? false;

export const useFeatureFlagPayload = <K extends FeatureFlag>(key: K): FeatureFlagPayloadMap[K] | undefined =>
  usePostHogFeatureFlagPayload(key) as FeatureFlagPayloadMap[K] | undefined;
